<template>
  <v-treeview
    ref="catalog"
    activatable
    :active="selectedPositions"
    active-class="black--text"
    color="var(--black-color)"
    hoverable
    item-key="id"
    item-text="title"
    :items="items"
    :load-children="loadChildren"
    multiple-active
    :open.sync="opened"
    :open-on-click="true"
    return-object
    :search="search"
    selected-color="var(--black-color)"
    transition
    :value="selectedPositions"
    @input="select">
    <template #label="{ item }">
      <div
        class="tree-item black--text pr-3">
        <slot name="tree-name">
          {{ item.name || item.fullName || item.title }}
        </slot>
      </div>
    </template>
    <template #prepend="{ item, indeterminate, open: openPrepend, selected }">
      <slot name="prepend">
        <div
          class="flex flex-wrap align-center"
          @click="!(!!item.children || disable) ? addItem(item, selected) : null">
          <sIcon
            v-if="!!item.children"
            class="mr-2 ml-1"
            :rotate="openPrepend ? 0 : -90"
            size="10"
            type="arrow"/>
          <sIcon
            class="mr-2"
            :color="!!item.children || disable ? '#d3dbda' : 'var(--black-color)'"
            :type="indeterminate ? 'checkbox-indeterminate' : (selected ? 'checkbox' : 'checkbox-empty')"/>
        </div>
      </slot>
    </template>
    <template #append="{ item }">
      <slot name="append">
        <span
          class="secondary__green_not_active--text"
          :title="item.append_text_title">
          {{ item.append_text }}
        </span>
        <div
          v-if="accessMulti && !(!!item.children || disable)"
          class="block-button-add">
          <sButton
            icon="import"
            small
            type="text"
            @click="addItem(item, false)">
            {{ $t('Tenders.AddProduct') }}
          </sButton>
        </div>
      </slot>
    </template>
  </v-treeview>
</template>
<script>

export default {
  name: 'resourceTreeTender',
  data() {
    return {
      accessMulti: false
    }
  },
  methods: {
    addItem(item, state) {
      this.$emit(state ? 'removeItem' : 'addItem', this.$_.cloneDeep(item))
    },
    select(input) {
      this.$emit('input', input)
    },
  },
  computed: {
    opened: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    },
  },
  props: {
    items: {
      type: Array
    },
    selectedPositions: {
      type: Array
    },
    loadChildren: {
      type: Function
    },
    open: {
      type: Array
    },
    search: {
      type: String,
    },
    disable: {
      type: Boolean,
    },
    append_text: Function,
    append_text_title: Function
  },
  mounted() {
    this.accessMulti = this.$can('use', 'availableAdditionalFields')
  }
}
</script>
<style scoped lang="scss">
::v-deep .v-treeview-node__root {
  &>.v-treeview-node__content {
    cursor: default !important;
  }
  &>.v-treeview-node__content>.v-treeview-node__append {
    display: flex;
    justify-content: space-between;
    &>.block-button-add {
      display: flex;
      position: absolute;
      right: 0;
      bottom: 0;
      top: 0;
      background: var(--v-secondary__green_chosen-base);
      margin: auto 0;
      max-width: 0;
      overflow: hidden;
      transition: all 0.5s;
      button {
        margin: auto 0;
      }
    }
  }
  &:hover,
  &:focus {
    &>.v-treeview-node__content>.v-treeview-node__append>.block-button-add {
      max-width: inherit;
    }
  }
}
.tree-item {
  cursor: default !important;
}
</style>
